var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34923 0.240743C7.72372 -0.0802478 8.27632 -0.0802478 8.65081 0.240743L15.6508 6.24074C16.0701 6.60017 16.1187 7.23147 15.7593 7.65079C15.3999 8.07012 14.7686 8.11868 14.3492 7.75926L8.00002 2.31708L1.65081 7.75926C1.23148 8.11868 0.600184 8.07012 0.240762 7.65079C-0.118661 7.23147 -0.0700991 6.60017 0.349227 6.24074L7.34923 0.240743Z",
    fill: "#181C21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpChevron);
export default __webpack_public_path__ + "static/media/up_chevron.a8477435b47031b1ba40629b7da301eb.svg";
export { ForwardRef as ReactComponent };